import {
    isSameOrder,
    placedBrokerOrder,
    PlacedOrders,
    placedSimulatedOrder
} from "../../store/placed/models/PlacedOrder";
import {isIressOrderModel} from "../../models/iress/IressOrderViewModel";
import {ArrayUtil} from "../../../js/util/ArrayUtil";
import {isSimulatedOrderModel} from "../../models/simulated/SimulatedOrderViewModel";
import {OrderEvent} from "../../models/events/OrderEvent";

export function isUserEvent(event: OrderEvent, placed: PlacedOrders): boolean {
    const model = event.order;

    if (isIressOrderModel(model)) {
        const order = placedBrokerOrder(model.orderNumber);
        return ArrayUtil.includes(placed, order, isSameOrder);
    } else if (isSimulatedOrderModel(model)) {
        const order = placedSimulatedOrder(model.id);
        return ArrayUtil.includes(placed, order, isSameOrder);
    } else {
        return false;
    }
}
